import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Menu, Phone, Mail } from 'lucide-react';
import logo from '@/images/Logo_Schteffann_505x125.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Über mich', href: '/ueber-mich' },
    { name: 'Leistungen', href: '/services' },
    { name: 'Pakete & Preise', href: '/support' },
    { name: 'Referenzen', href: '/referenzen' },
    { name: 'Wissen', href: '/wissen' },
    { name: 'Kontakt', href: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-white/95 backdrop-blur-xl supports-[backdrop-filter]:bg-white/90 shadow-lg">
      <div className="flex items-center justify-between py-4 px-4 min-h-[80px]">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3 group">
          <div className="relative">
            <img
              src={logo}
              alt="Schteffann Logo"
              className="h-12 w-auto transition-all duration-300 group-hover:scale-105"
            />
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`relative text-sm font-medium transition-all duration-300 hover:text-cyan-600 ${
                isActive(item.href)
                  ? 'text-cyan-600'
                  : 'text-slate-700'
              }`}
            >
              {item.name}
              {isActive(item.href) && (
                <div className="absolute -bottom-6 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full" />
              )}
            </Link>
          ))}
        </nav>

        {/* Desktop Contact Info */}
        <div className="hidden lg:flex items-center space-x-6">
          <a
            href="tel:015679697252"
            className="flex items-center space-x-2 text-sm text-slate-600 hover:text-cyan-600 transition-all duration-300 group"
          >
            <div className="p-2 rounded-full bg-gradient-to-r from-cyan-50 to-blue-50 group-hover:from-cyan-100 group-hover:to-blue-100 transition-all">
              <Phone className="h-4 w-4 text-cyan-600" />
            </div>
            <span className="font-medium">0156-79697252</span>
          </a>
          {/* Mail-Adresse entfernt‚
          <a
            href="mailto:koOntakt@schteffann.de"
            className="flex items-center space-x-2 text-sm text-slate-600 hover:text-cyan-600 transition-all duration-300 group"
          >
            <div className="p-2 rounded-full bg-gradient-to-r from-cyan-50 to-blue-50 group-hover:from-cyan-100 group-hover:to-blue-100 transition-all">
              <Mail className="h-4 w-4 text-cyan-600" />
            </div>
            <span className="font-medium">ko0ntakt@schteffann.de</span>
          </a>
          */}
        </div>

        {/* Mobile Menu */}
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="sm" className="hover:bg-cyan-50">
              <Menu className="h-5 w-5 text-cyan-600" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px] bg-white">
            <div className="flex flex-col space-y-6 mt-8">
              <div className="flex items-center space-x-3 pb-4 border-b border-slate-200">
                <img
                  src={logo}
                  alt="Schteffann Logo"
                  className="h-10 w-auto"
                />
              </div>

              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-lg font-medium transition-colors hover:text-cyan-600 ${
                    isActive(item.href) ? 'text-cyan-600' : 'text-slate-700'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}

              <div className="border-t pt-6 mt-8">
                <div className="space-y-4">
                  <a
                    href="tel:015679697252"
                    className="flex items-center space-x-3 text-slate-600 hover:text-cyan-600 transition-colors"
                  >
                    <Phone className="h-4 w-4" />
                    <span>0156-79697252</span>
                  </a>
                  {/* Mail-Adresse entfernt}
                  <a
                    href="mailto:kontakt@schteffann.de"
                    className="flex items-center space-x-3 text-slate-600 hover:text-cyan-600 transition-colors"
                  >
                    <Mail className="h-4 w-4" />
                    <span>kontakt@schteffann.de</span>
                  </a>
                  */}
                </div>
              </div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default Header;
